import App from 'app/app.js';
import 'app/service/PostalCodeValidationService.js';

function LtAddressValidationDirective(AddressConsistencyService) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function (scope, element, attrs, ctrl) {
      const validate = function (stateProvince, address) {
        const isRestrictedAddress = AddressConsistencyService.isAddressRestricted(stateProvince, address);

        const isStreet = attrs.ltAddressType === 'streetAddress';
        const isAptSuite = attrs.ltAddressType === 'aptSuite';

        if (isStreet) {
          scope.billingInfo.isAddressOneRestricted = isRestrictedAddress;
        }
        if (isAptSuite) {
          scope.billingInfo.isAddressTwoRestricted = isRestrictedAddress;
        }

        scope.billingInfo.showRestrictionBanner =
          scope.billingInfo.isAddressOneRestricted || scope.billingInfo.isAddressTwoRestricted;

        return address;
      };

      var unwatch = scope.$watch(attrs.ltStateProvince, function (value) {
        validate(value, ctrl.$viewValue);
      });

      ctrl.$parsers.push(function (modelValue) {
        return validate(scope.$eval(attrs.ltStateProvince), modelValue);
      });

      scope.$on('$destroy', function () {
        unwatch();
      });
    }
  };
}

App.directive('ltAddressValidation', ['AddressConsistencyService', LtAddressValidationDirective]);
